import { CSSObject } from '@emotion/react';
export type Stylesheet = Record<string, CSSObject>;

export const breakpoints = {
  mobile: 320,
  tablet: 768,
  desktop: 1280,
};

export const media = {
  mobile: '@media (min-width: 320px)',
  tablet: '@media (min-width: 768px)',
  desktop: '@media (min-width: 1280px)',
  hover: '@media (hover: hover) and (pointer: fine)',
};
